import React, { useEffect } from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';

type Props = any;
const DropdownUI: React.FC<Props> = ({ val, setVal, filteredCards }) => {
  useEffect(() => {
    filteredCards(val);
  }, [val]);

  return (
    <>
      <DropdownButton title={val ? val : 'Ticket Type'}>
        {['ALL', 'OPEN', 'IN-REVIEW', 'RESOLVED'].map((item, idx) => (
          <Dropdown.Item as="button" onClick={() => setVal(item)} key={idx}>
            {item}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </>
  );
};

export default DropdownUI;
